(function(){
'use strict';

/* ═══ HEADER — transparent on homepage at top, solid on scroll or other pages ═══ */
const header = document.querySelector('.header');
if(header){
  const isIndex = document.body.classList.contains('template-index');
  const checkScroll = () => {
    if(isIndex){
      header.classList.toggle('header--scrolled', window.scrollY > 100);
    }
  };
  if(isIndex){
    checkScroll();
    window.addEventListener('scroll', checkScroll, {passive:true});
  }
}

/* ═══ ANNOUNCEMENT BAR DISMISS ═══ */
const annClose = document.querySelector('.announcement-bar__close');
const annBar = document.querySelector('.announcement-bar');
function dismissAnnouncement(){
  if(!annBar) return;
  annBar.classList.add('announcement-bar--hidden');
  annBar.style.display='none';
  document.documentElement.style.setProperty('--announcement-height','0px');
  if(header) header.style.top='0';
}
if(annClose){
  annClose.addEventListener('click', () => {
    dismissAnnouncement();
    sessionStorage.setItem('ys-ann-off','1');
  });
}
if(sessionStorage.getItem('ys-ann-off')==='1') dismissAnnouncement();
// Set announcement height CSS var on load
if(annBar && !annBar.classList.contains('announcement-bar--hidden')){
  const h = annBar.offsetHeight;
  document.documentElement.style.setProperty('--announcement-height', h+'px');
  if(header) header.style.top = h+'px';
}

/* ═══ CART DRAWER — Full AJAX with working checkout ═══ */
const cartDrawer = document.querySelector('.cart-drawer');
const cartOverlay = document.querySelector('.cart-drawer__overlay');
const body = document.body;

function openCart(){ if(cartDrawer){ cartDrawer.classList.add('cart-drawer--open'); cartOverlay?.classList.add('cart-drawer__overlay--visible'); body.style.overflow='hidden'; refreshCart(); } }
function closeCart(){ if(cartDrawer){ cartDrawer.classList.remove('cart-drawer--open'); cartOverlay?.classList.remove('cart-drawer__overlay--visible'); body.style.overflow=''; } }

document.querySelectorAll('[data-cart-open]').forEach(b=>{
  var cartTapped = false;
  b.addEventListener('touchend',function(e){
    e.preventDefault();
    e.stopPropagation();
    if(!cartTapped){cartTapped=true;openCart();setTimeout(function(){cartTapped=false;},300);}
  },{passive:false});
  b.addEventListener('click',function(e){
    e.preventDefault();
    e.stopPropagation();
    if(!cartTapped){openCart();}
    cartTapped=false;
  });
});
document.querySelectorAll('[data-cart-close]').forEach(b=>{
  b.addEventListener('click',e=>{e.preventDefault();closeCart();});
  b.addEventListener('touchend',e=>{e.preventDefault();closeCart();},{passive:false});
});
if(cartOverlay){
  cartOverlay.addEventListener('click',closeCart);
  cartOverlay.addEventListener('touchend',e=>{e.preventDefault();closeCart();},{passive:false});
}

async function refreshCart(){
  try{
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderCart(cart);
    updateCartCount(cart.item_count);
  }catch(e){console.error('Cart fetch error',e);}
}

function updateCartCount(count){
  document.querySelectorAll('.header__cart-count').forEach(el=>{
    el.textContent=count;
    el.style.display=count>0?'flex':'none';
  });
  document.querySelectorAll('.cart-drawer__title').forEach(el=>{
    el.textContent='Bag ('+count+')';
  });
}

function renderCart(cart){
  const itemsEl = document.querySelector('.cart-drawer__items');
  var footerEl = document.querySelector('.cart-drawer__footer');
  if(!itemsEl) return;

  if(cart.item_count === 0){
    itemsEl.innerHTML = '<div class="cart-drawer__empty">Your bag is empty<br><br><a href="/collections/all" class="btn btn--secondary btn--sm" style="font-size:.6rem;padding:10px 24px;">Continue Shopping</a></div>';
    if(footerEl) footerEl.style.display = 'none';
    return;
  }

  // Build items
  let html = '';
  cart.items.forEach(item => {
    const img = item.image ? '<img src="'+item.image.replace(/(\.[^.]+)$/,'_200x$1')+'" alt="'+item.title+'" loading="lazy">' : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-drawer__item-variant">'+item.variant_title+'</p>' : '';
    html += '<div class="cart-drawer__item">';
    html += '<div class="cart-drawer__item-img"><a href="'+item.url+'">'+img+'</a></div>';
    html += '<div><p class="cart-drawer__item-title">'+item.product_title+'</p>'+variant+'<p class="cart-drawer__item-price">'+formatMoney(item.final_line_price)+'</p><p class="body-xs" style="color:var(--color-text-light);margin-top:4px;">Qty: '+item.quantity+'</p><button class="cart-drawer__item-remove" data-remove-key="'+item.key+'">Remove</button></div>';
    html += '</div>';
  });
  itemsEl.innerHTML = html;

  // Create or update footer with checkout
  if(!footerEl){
    footerEl = document.createElement('div');
    footerEl.className = 'cart-drawer__footer';
    cartDrawer.appendChild(footerEl);
  }
  footerEl.style.display = '';
  var total = formatMoney(cart.total_price);
  footerEl.innerHTML = '<div class="cart-drawer__summary"><div class="cart-drawer__summary-row"><span>Subtotal</span><span class="cart-drawer__subtotal-amount">'+total+'</span></div><div class="cart-drawer__summary-row cart-drawer__summary-row--light"><span>Shipping</span><span>Complimentary</span></div><div class="cart-drawer__summary-row cart-drawer__summary-total"><span>Estimated Total</span><span>'+total+'</span></div></div><a href="/checkout" class="btn btn--primary btn--full">Checkout</a><div class="cart-drawer__info"><p class="cart-drawer__info-line"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="flex-shrink:0"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>Free worldwide shipping — 7-14 business days</p><p class="cart-drawer__info-line"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="flex-shrink:0"><path d="M21 4H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"/><line x1="1" y1="10" x2="23" y2="10"/></svg>Secure payment via card, PayPal &amp; more</p><p class="cart-drawer__info-line"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="flex-shrink:0"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>30-day easy returns</p></div>';

  // Bind remove buttons
  itemsEl.querySelectorAll('[data-remove-key]').forEach(btn=>{
    btn.addEventListener('click', async ()=>{
      btn.textContent = 'Removing...';
      await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:btn.dataset.removeKey,quantity:0})});
      refreshCart();
    });
  });
}

function formatMoney(cents){
  return (cents/100).toLocaleString(undefined,{style:'currency',currency:window.Shopify?.currency?.active||'EUR',minimumFractionDigits:2});
}

/* ═══ ADD TO CART — Smooth AJAX ═══ */
document.addEventListener('submit', async (e)=>{
  const form = e.target.closest('[data-add-to-cart]');
  if(!form) return;
  e.preventDefault();
  const btn = form.querySelector('[type="submit"]');
  if(!btn || btn.disabled) return;
  const origText = btn.textContent;
  btn.textContent = 'Adding...';
  btn.disabled = true;

  try{
    const fd = new FormData(form);
    const res = await fetch('/cart/add.js',{method:'POST',body:fd});
    if(res.ok){
      btn.textContent = 'Added ✓';
      updateCartCount((await (await fetch('/cart.js')).json()).item_count);
      // Show toast notification instead of opening drawer
      showCartToast(btn.closest('form'));
    } else {
      const err = await res.json();
      btn.textContent = err.description || 'Error';
    }
  }catch(err){
    btn.textContent = 'Error';
  }
  setTimeout(()=>{ btn.textContent = origText; btn.disabled = false; }, 2000);
});

/* ═══ CHECKOUT BUTTON — Direct link, always works ═══ */
document.addEventListener('click', (e)=>{
  const btn = e.target.closest('[data-checkout]');
  if(btn){
    e.preventDefault();
    window.location.href = '/checkout';
  }
});

/* ═══ SEARCH OVERLAY ═══ */
const searchOverlay = document.querySelector('.search-overlay');
document.querySelectorAll('[data-search-open]').forEach(b=>{
  function openSearch(e){e.preventDefault();if(searchOverlay){searchOverlay.classList.add('search-overlay--open');body.style.overflow='hidden';setTimeout(()=>{const i=searchOverlay.querySelector('.search-overlay__input');if(i)i.focus();},100);}}
  b.addEventListener('click',openSearch);
  b.addEventListener('touchend',openSearch,{passive:false});
});
document.querySelectorAll('[data-search-close]').forEach(b=>{
  function closeSearch(e){e.preventDefault();if(searchOverlay){searchOverlay.classList.remove('search-overlay--open');body.style.overflow='';}}
  b.addEventListener('click',closeSearch);
  b.addEventListener('touchend',closeSearch,{passive:false});
});

/* ═══ MOBILE MENU ═══ */
const mobileMenu = document.querySelector('.mobile-menu');
document.querySelectorAll('[data-menu-open]').forEach(b=>{
  b.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();if(mobileMenu){mobileMenu.classList.add('mobile-menu--open');body.style.overflow='hidden';}});
  b.addEventListener('touchend',e=>{e.preventDefault();e.stopPropagation();if(mobileMenu){mobileMenu.classList.add('mobile-menu--open');body.style.overflow='hidden';}},{passive:false});
});
document.querySelectorAll('[data-menu-close]').forEach(b=>{
  b.addEventListener('click',e=>{
    if(mobileMenu){mobileMenu.classList.remove('mobile-menu--open');body.style.overflow='';}
    if(b.tagName==='BUTTON'){e.preventDefault();}
  });
  b.addEventListener('touchend',e=>{
    if(mobileMenu){mobileMenu.classList.remove('mobile-menu--open');body.style.overflow='';}
    if(b.tagName==='BUTTON'){e.preventDefault();}
  },{passive:false});
});

/* Mobile accordion submenus */
document.querySelectorAll('[data-mobile-toggle]').forEach(trigger=>{
  function toggleSub(e){
    e.preventDefault();
    const sub = trigger.nextElementSibling;
    if(sub){
      const isOpen = sub.style.maxHeight && sub.style.maxHeight !== '0px';
      sub.style.maxHeight = isOpen ? '0px' : sub.scrollHeight + 'px';
      sub.style.overflow = 'hidden';
      sub.style.transition = 'max-height .3s ease';
    }
  }
  trigger.addEventListener('click', toggleSub);
  trigger.addEventListener('touchend', toggleSub, {passive:false});
});

/* ═══ ESCAPE KEY ═══ */
document.addEventListener('keydown',(e)=>{
  if(e.key==='Escape'){closeCart();
    if(searchOverlay) searchOverlay.classList.remove('search-overlay--open');
    if(mobileMenu) mobileMenu.classList.remove('mobile-menu--open');
    body.style.overflow='';
    closeZoom();
  }
});

/* ═══ IMAGE ZOOM ═══ */
const zoomModal = document.querySelector('.zoom-modal');
const zoomImg = zoomModal?.querySelector('img');

function openZoom(src){
  if(!zoomModal||!zoomImg) return;
  zoomImg.src = src;
  zoomModal.classList.add('zoom-modal--open');
  body.style.overflow = 'hidden';
}
function closeZoom(){
  if(!zoomModal) return;
  zoomModal.classList.remove('zoom-modal--open');
  body.style.overflow = '';
}

// Product gallery zoom
document.querySelectorAll('.product__gallery-item').forEach(item=>{
  item.addEventListener('click',()=>{
    const img = item.querySelector('img');
    if(img){
      // Get high-res version
      let src = img.src;
      src = src.replace(/_\d+x\d*\./,'_1600x.');
      src = src.replace(/width=\d+/,'width=1600');
      openZoom(src);
    }
  });
});

// Any zoomable image
document.querySelectorAll('[data-zoomable]').forEach(img=>{
  img.style.cursor = 'zoom-in';
  img.addEventListener('click',()=>{
    let src = img.src;
    src = src.replace(/_\d+x\d*\./,'_1600x.');
    src = src.replace(/width=\d+/,'width=1600');
    openZoom(src);
  });
});

if(zoomModal){
  zoomModal.addEventListener('click',(e)=>{
    if(e.target===zoomModal || e.target.closest('.zoom-modal__close')) closeZoom();
  });
}

/* ═══ PRODUCT ACCORDIONS ═══ */
document.querySelectorAll('.product__accordion-trigger').forEach(trigger=>{
  trigger.addEventListener('click',()=>{
    const content = trigger.nextElementSibling;
    const isOpen = trigger.getAttribute('aria-expanded')==='true';
    trigger.setAttribute('aria-expanded',!isOpen);
    content.style.maxHeight = isOpen ? '0' : content.scrollHeight+'px';
  });
});

/* ═══ PRODUCT VARIANT SELECTION ═══ */
(function(){
  var variantsEl = document.getElementById('product-variants-json');
  if(!variantsEl) return;
  var variants = [];
  try { variants = JSON.parse(variantsEl.textContent); } catch(e){ return; }
  
  var idInput = document.querySelector('[data-add-to-cart] input[name="id"]');
  var priceEl = document.querySelector('.product__price');
  var addBtn = document.querySelector('.product__add');
  var optionGroups = document.querySelectorAll('.product__variant-options');
  
  function getSelectedOptions(){
    var selected = [];
    optionGroups.forEach(function(group){
      var active = group.querySelector('.product__variant-option--active');
      if(active) selected.push(active.dataset.value);
    });
    return selected;
  }
  
  function findVariant(options){
    for(var i=0;i<variants.length;i++){
      var v = variants[i];
      var match = true;
      for(var j=0;j<options.length;j++){
        if(v['option'+(j+1)] !== options[j]){ match=false; break; }
      }
      if(match) return v;
    }
    return null;
  }
  
  function formatMoney(cents){
    return (cents/100).toLocaleString(undefined,{style:'currency',currency:window.Shopify&&Shopify.currency&&Shopify.currency.active||'EUR',minimumFractionDigits:2});
  }
  
  function updateVariant(){
    var options = getSelectedOptions();
    var variant = findVariant(options);
    if(!variant) return;
    
    // Update hidden ID
    if(idInput) idInput.value = variant.id;
    
    // Update price
    if(priceEl){
      var html = '';
      if(variant.compare_at_price && variant.compare_at_price > variant.price){
        html += '<span class="product-card__price-compare">' + formatMoney(variant.compare_at_price) + '</span>';
      }
      html += formatMoney(variant.price);
      priceEl.innerHTML = html;
    }
    
    // Update button
    if(addBtn){
      if(variant.available){
        addBtn.disabled = false;
        addBtn.textContent = addBtn.dataset.addText || 'Add to Bag';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.dataset.soldText || 'Sold Out';
      }
    }
    
    // Update URL without reload
    if(history.replaceState){
      var url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }
  }
  
  // Bind click + touch on all variant options
  document.querySelectorAll('.product__variant-option').forEach(function(opt){
    function handleSelect(){
      opt.closest('.product__variant-options').querySelectorAll('.product__variant-option').forEach(function(o){o.classList.remove('product__variant-option--active');});
      opt.classList.add('product__variant-option--active');
      updateVariant();
    }
    opt.addEventListener('click', handleSelect);
    opt.addEventListener('touchend', function(e){e.preventDefault();handleSelect();}, {passive:false});
  });

/* ═══ ACCOUNT + HEADER LINKS — mobile touch fix ═══ */
document.querySelectorAll('.header__icon[href]').forEach(function(link){
  link.addEventListener('touchend', function(e){
    // Don't intercept cart/search/menu buttons
    if(link.hasAttribute('data-cart-open') || link.hasAttribute('data-search-open') || link.hasAttribute('data-menu-open')) return;
    e.preventDefault();
    window.location.href = link.getAttribute('href');
  }, {passive: false});
});

})();

/* ═══ QUANTITY SELECTOR ═══ */
document.querySelectorAll('.qty').forEach(qty=>{
  const input = qty.querySelector('.qty__input');
  qty.querySelector('[data-qty-minus]')?.addEventListener('click',()=>{const v=parseInt(input.value)||1;if(v>1)input.value=v-1;});
  qty.querySelector('[data-qty-plus]')?.addEventListener('click',()=>{const v=parseInt(input.value)||1;input.value=v+1;});
});

/* ═══ SCROLL REVEAL ═══ */
if('IntersectionObserver' in window){
  const ro = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('reveal--visible');ro.unobserve(e.target);}});
  },{threshold:.12,rootMargin:'0px 0px -30px 0px'});
  document.querySelectorAll('.reveal').forEach(el=>ro.observe(el));
}

/* page transitions removed */


/* ═══ CART TOAST — shows confirmation without opening drawer ═══ */
function showCartToast(){
  var existing = document.querySelector('.cart-toast');
  if(existing) existing.remove();
  var toast = document.createElement('div');
  toast.className = 'cart-toast';
  toast.innerHTML = '<span>Added to bag</span><a href="#" class="cart-toast__view" data-cart-open>View Bag</a>';
  document.body.appendChild(toast);
  // Animate in
  requestAnimationFrame(function(){toast.classList.add('cart-toast--visible');});
  // Bind view bag click
  toast.querySelector('[data-cart-open]').addEventListener('click',function(e){e.preventDefault();toast.remove();openCart();});
  toast.querySelector('[data-cart-open]').addEventListener('touchend',function(e){e.preventDefault();toast.remove();openCart();},{passive:false});
  // Auto dismiss after 3s
  setTimeout(function(){toast.classList.remove('cart-toast--visible');setTimeout(function(){toast.remove();},400);},3000);
}

})();

/* ═══ MOBILE PRODUCT GALLERY CAROUSEL ═══ */
;(function(){
  const gallery = document.querySelector('.product__gallery');
  const dots = document.querySelectorAll('.product__gallery-dot');
  if(!gallery || dots.length === 0) return;

  // Update dots on scroll
  let scrollTimeout;
  gallery.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      const scrollLeft = gallery.scrollLeft;
      const itemWidth = gallery.children[0]?.offsetWidth || 1;
      const index = Math.round(scrollLeft / itemWidth);
      dots.forEach((dot, i) => {
        dot.classList.toggle('product__gallery-dot--active', i === index);
      });
    }, 50);
  }, {passive: true});

  // Click dot to scroll
  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      const itemWidth = gallery.children[0]?.offsetWidth || 0;
      gallery.scrollTo({ left: itemWidth * i, behavior: 'smooth' });
    });
  });
})();
